export const JOURNEY_PLANNER_OPEN_EVENT = 'journey-planner:open';
export const JOURNEY_PLANNER_CLOSE_EVENT = 'journey-planner:close';

export function openJourneyPlanner(context = {}) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(JOURNEY_PLANNER_OPEN_EVENT, { detail: context }));
}

export function closeJourneyPlanner() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(JOURNEY_PLANNER_CLOSE_EVENT));
}
